module.exports = __webpack_public_path__ + "img/bcgyl.4b05224d.png";